export const commaNumberFormat = (num) => {
  if (!num) return "";
  const numStr = num.toString();
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const commaDescreteNumberFormat = (num) => {
  if (!num) return "";
  const intNum = parseInt(num, 10); // drops decimals
  return intNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function formatMoneyInput(raw) {
  if (!raw) return "";
  // Strip any non-digit/non-dot chars (just in case):
  const cleaned = raw.replace(/[^0-9.]/g, "");
  // Split integer vs fraction
  const [intPart, fracPart] = cleaned.split(".");
  // Inject commas into the integer
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // Reassemble
  return fracPart != null ? `${withCommas}.${fracPart}` : withCommas;
}
